module.exports = __webpack_public_path__ + "img/gcp.2bdb5143.png";